<template>
  <div class="full-video-player" v-if="videoShow">
    <div class="btn-close" @click="hide"></div>
    <video id="big-v" :src="src" ref="bVideoPlayer"
           type="video/mp4"
           :poster="poster"
           preload="auto" loop controlslist="nodownload" :disablePictureInPicture="true"
           oncontextmenu="return false"  webkit-playsinline
           @pause="onPlayerPause($event)"
           @play="onPlayerPlay($event)"
           @ended="onPlayerEnded($event)"
           @waiting="onPlayerWaiting($event)"
           @playing="onPlayerPlaying($event)"
           @loadeddata="onPlayerLoadeddata($event)"
           @timeupdate="onPlayerTimeupdate($event)"
           @canplay="onPlayerCanplay($event)"
           @canplaythrough="onPlayerCanplaythrough($event)"
           @statechanged="playerStateChanged($event)"
           @ready="playerReadied"
    ></video>
  </div>
</template>
<script>

  import {hideDialog, showDialog} from "../../utils/tools";

  export default {
    name:'VideoPlayer',
    props: {
      videoShow:false,
      src: {
        type: String
      },
      poster:{
        type: String
      },
    },
    data() {
      return {

      }
    },
    mounted() {
      console.log('this is current player instance object', this.player)
    },
    computed: {

    },
    methods: {
      hide(){
        this.$emit('hideHLSPlayer')
      },
      setSrc(src) {
        // 重新设置播放地址
        setTimeout(()=>{
          this.$refs.bVideoPlayer.play() // 播放
        }, 1000)
      },
      play() {
        // 手动触发播放
        this.$refs.bVideoPlayer.play() // 播放
      },
      pause() {
        // 手动触发播放
        this.$refs.bVideoPlayer.pause() // 播放
      },
      // listen event
      onPlayerPlay(player) {
        console.log('player play!', player)
      },
      onPlayerPause(player) {
        this.hide()

      },
      onPlayerEnded(player) {
      },
      onPlayerWaiting(player) {
      },
      onPlayerPlaying(player) {
      },
      onPlayerLoadeddata(player) {
        this.play()
      },
      onPlayerTimeupdate(player) {
      },
      onPlayerCanplay(player) {
        console.log('player onPlayerCanplay!', player)
        this.play()
        hideDialog(this)
      },
      onPlayerCanplaythrough(player) {
      },
      // ...player event

      // or listen state event
      playerStateChanged(playerCurrentState) {
      },

      // player is ready
      playerReadied(player) {
        // you can use it to do something...
        // player.[methods]
      }
    },
    watch:{
      videoShow(n,o){
        showDialog(this,null,false)
        let t=this
        if (n){
          this.$nextTick(()=>{
            t.play()
          })

          // document.addEventListener('touchstart',this.play)
        }else {
          hideDialog(this)
          // document.removeEventListener('touchstart',this.play)
        }
      }
    }

  }
</script>
<style lang="less" >
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .full-video-player{
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, .7);
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .btn-close{
      .w(72);
      .h(72);
      background: url(../../assets/imgs/close-video-btn.png) no-repeat center;
      background-size: contain;
      .top(50);
      .right(30);
      cursor: pointer;
      z-index: 2;
      position: absolute;

    }

    video{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/widget/VideoPlayer.vue